import { ReactComponent as IdHorizontalIcon } from '../../../../assets/icons/id-icon.svg'
import { ReactComponent as IdVerticalIcon } from '../../../../assets/icons/passport-icon.svg'
import { ReactComponent as RefreshIcon } from '../../../../assets/icons/arrow-path.svg'
import { ReactComponent as IntPassportIcon } from '../../../../assets/icons/arrow-path.svg'
import { ReactComponent as CheckIcon } from '../../../../assets/icons/check.svg'
import { ReactComponent as UserIcon } from '../../../../assets/icons/user.svg'
import { ReactComponent as SelfieIcon } from '../../../../assets/icons/selfie-icon.svg'
import {Icons} from "./Icons";

const DefaultIcons: Icons = {
    idHorizontal: <IdHorizontalIcon/>,
    idVertical: <IdVerticalIcon/>,
    intPassport: <IntPassportIcon/>,
    user: <UserIcon/>,
    check: <CheckIcon/>,
    refresh: <RefreshIcon/>,
    selfie: <SelfieIcon/>
}

export default DefaultIcons